import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import videojs, { VideoJsPlayer } from 'video.js';
declare var $: any;

@Component({
  selector: 'app-about-nma',
  templateUrl: './about-nma.component.html',
  styleUrls: ['./about-nma.component.css']
})
export class AboutNmaComponent implements OnInit {
  baseUrl = environment.staticUrlForImgNew
  @Input() gardenJWGData:any;
  @ViewChild('videoPlayer', { static: false }) videoElement!: ElementRef;
  player!: VideoJsPlayer;
  isNMApopupOpen: boolean = false;

  isVisible = false;
  videoSrc: string = '';
  isModalMuted = false;

  constructor(private renderer: Renderer2) { }

  ngOnInit(): void {
  }

  async ngAfterViewInit() {
    try {
      await this.loadScript('assets/nycJs/jquery-3.3.1.min.js');

      if (!(window as any).jQuery) {
        throw new Error('jQuery not available globally');
      }
      
      await this.loadScript('assets/nycJs/main.js');
      await this.loadScript('assets/nycJs/wow.min.js');
      

      console.log('All scripts loaded');
    } catch (error) {
      console.error('Script loading failed:', error);
    }   

  }
  loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = this.renderer.createElement('script');
      script.src = src;
      script.type = 'text/javascript';
      script.onload = () => {
        console.log(`${src} loaded`);
        resolve();
      };
      script.onerror = (err) => reject(err);
      this.renderer.appendChild(document.body, script);
    });
    
  }
  openVideoModal(src: string) {
    this.videoSrc = src;
    this.isModalMuted = true; 
    const isMp4 = /\.mp4(\?.*)?$/i.test(src);
    const mimeType = isMp4 ? 'video/mp4' : 'application/x-mpegURL';
      
    // $('#nma-about-modal').modal('show');
    this.isNMApopupOpen = true;
      
    setTimeout(() => {
      if (!this.player) {
        this.player = videojs(this.videoElement.nativeElement, {
          autoplay: true,
          controls: true,
          muted: true,    
          bigPlayButton: false,         
          sources: [
            {
              src: this.videoSrc,
              type: mimeType,
            },
          ],
        });
      } else {
        this.player.src({ src: this.videoSrc, type: mimeType });
        this.player.muted(true);    // Unmute if player already exists
        this.player.play();
      }
    }, 300);
  }
  
  toggleMuteModal() {
    this.isModalMuted = !this.isModalMuted;
    if (this.player) {
      this.player.muted(this.isModalMuted);
    }
  }
  
  close() {
    this.isVisible = false;
    if (this.player) {
      this.player.pause();
      // $('#nma-about-modal').modal('hide');
      this.isNMApopupOpen = false; 
    }
  }

}
